export default "__VITE_ASSET__BIqQZs4q__"